import { Outlet, useLocation } from 'react-router-dom';
import NavbarTemplate from '../components/template/public/NavbarTemplate';
import FooterTemplate from '../components/template/public/FooterTemplate';
import CTASection from '../components/common/CTASection';
import ScrollToTop from '../components/common/ScrollToTop';
import MetaManager from '../components/common/MetaManager';

const RootLayout = () => {
  const location = useLocation();
  const hideFooter = location.pathname === '/surgeon/profile';

  return (
    <>
      <MetaManager />
      <ScrollToTop />
      <NavbarTemplate />
      <main>
        <Outlet />
      </main>
      {!hideFooter && <CTASection />}
      {!hideFooter && <FooterTemplate />}
    </>
  );
};

export default RootLayout;
